import { Dispatch } from "redux"

import API from "../../Api"
import AuthHelper from "../../helpers/AuthHelper"
import CommonHelper from "../../helpers/CommonHelper"
import { TimelineApiItem, TimelineListPostBody, TimelineListPostFilters, TimelineQueryResult } from "../../types/TimelineType"

interface FetchTimelinePersonPayload {
  items: TimelineApiItem[]
  nextCursor?: string
  append: boolean
  personOrganizationRoleProgramId: string
}

type FetchTimelinePersonV2 = (
  organizationId: string,
  personOrganizationRoleProgramId: string,
  filters?: TimelineListPostFilters,
  cursor?: string,
  limit?: number,
  append?: boolean,
) => (dispatch: Dispatch) => void

type ClearTimelinePerson = () => (dispatch: Dispatch) => void

export interface TimelinePersonActions {
  fetchTimelinePersonV2: FetchTimelinePersonV2
  clearTimelinePerson: ClearTimelinePerson
}

class TimelinePerson {
  public static FETCH_TIMELINE_PERSON_TRIGGER = "FETCH_TIMELINE_PERSON_TRIGGER"
  public static FETCH_TIMELINE_PERSON_SUCCESS = "FETCH_TIMELINE_PERSON_SUCCESS"
  public static FETCH_TIMELINE_PERSON_ERROR = "FETCH_TIMELINE_PERSON_ERROR"
  public static CLEAR_TIMELINE_PERSON = "CLEAR_TIMELINE_PERSON"

  public static fetchTimelinePersonV2: FetchTimelinePersonV2 =
    (organizationId, personOrganizationRoleProgramId, filters = {}, cursor, limit, append = false) =>
    async (dispatch) => {
      if (!AuthHelper.canAccessTimeline(organizationId)) {
        return
      }

      try {
        dispatch({ type: TimelinePerson.FETCH_TIMELINE_PERSON_TRIGGER })

        const body: TimelineListPostBody = JSON.parse(
          JSON.stringify({
            ...filters,
            limit: limit ?? 20,
            ...(cursor ? { cursor } : {}),
            ...(personOrganizationRoleProgramId ? { personOrganizationRoleProgramId } : {}),
          }),
        )

        const res = await API.post(`/v1/organizations/${organizationId}/v2/timeline`, body, {
          headers: {
            ...AuthHelper.getAdminHeaders(),
            "Content-Type": "application/json",
          },
        })

        const responseData = res.data as TimelineQueryResult | { data?: TimelineQueryResult }
        const timelineData: TimelineQueryResult = "data" in responseData && responseData.data ? responseData.data : (responseData as TimelineQueryResult)
        const payload: FetchTimelinePersonPayload = {
          append,
          personOrganizationRoleProgramId,
          items: timelineData?.items || [],
          nextCursor: timelineData?.nextCursor,
        }

        dispatch({
          payload,
          type: TimelinePerson.FETCH_TIMELINE_PERSON_SUCCESS,
        })
      } catch (e) {
        const err: any = e as any
        dispatch({
          payload: CommonHelper.getErrorMessage(err),
          type: TimelinePerson.FETCH_TIMELINE_PERSON_ERROR,
        })
      }
    }

  public static clearTimelinePerson: ClearTimelinePerson = () => (dispatch: Dispatch) => {
    dispatch({
      type: TimelinePerson.CLEAR_TIMELINE_PERSON,
    })
  }
}

export default TimelinePerson
